
import { Card } from "@/components/ui/card";
import { AnalyticsInsight } from "@/types/assessment/analytics";
import { Zap, AlertCircle, Info } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

interface InsightCardProps {
  insight: AnalyticsInsight;
}

export const InsightCard = ({ insight }: InsightCardProps) => {
  const getPriorityIcon = () => {
    switch (insight.priority) {
      case "high":
        return <Zap className="h-5 w-5 text-amber-500" />;
      case "medium":
        return <Info className="h-5 w-5 text-blue-500" />;
      case "low":
        return <AlertCircle className="h-5 w-5 text-gray-400" />;
      default:
        return <Info className="h-5 w-5 text-blue-500" />;
    }
  };

  const getPriorityColor = () => {
    switch (insight.priority) {
      case "high":
        return "bg-amber-50 border-amber-200";
      case "medium":
        return "bg-blue-50 border-blue-200";
      case "low":
        return "bg-gray-50 border-gray-200";
      default:
        return "bg-blue-50 border-blue-200";
    }
  };

  const getTimeAgo = () => {
    try {
      return formatDistanceToNow(new Date(insight.timestamp), { addSuffix: true });
    } catch (e) {
      return "recently";
    }
  };

  return (
    <Card className={`p-4 border ${getPriorityColor()}`}>
      <div className="flex items-start gap-3">
        <div className="mt-1">{getPriorityIcon()}</div>
        <div className="flex-1">
          <div className="flex justify-between items-start">
            <h3 className="font-semibold text-gray-900">{insight.title}</h3>
            <span className="text-xs text-gray-500">{getTimeAgo()}</span>
          </div>
          <p className="mt-1 text-sm text-gray-600">{insight.description}</p>
          {insight.dimension && (
            <div className="mt-2">
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800 capitalize">
                {insight.dimension}
              </span>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};
